import { FormattedMessage } from '@futrli/localisation';
import { INTERCOM_LAUNCHER_ID } from '@futrli/shared-services';
import classNames from 'classnames';
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Button from 'carbon-react/lib/components/button';
import Box from 'carbon-react/lib/components/box';

import coreStyles from '../../core/common.scss';

export interface Props {
  icon: JSX.Element;
  title: JSX.Element;
  body: JSX.Element;
  showContactSupport?: boolean;
}

const InformativeDatasourceStatusMessageFC: React.FC<Props> = ({ icon, title, body, showContactSupport }: Props) => {
  return (
    <div className={classNames(coreStyles.allCaughtUp, coreStyles.predict)}>
      {icon}
      <Typography variant="h1">{title}</Typography>
      <Box maxWidth="500px" margin="0 auto" mt="8px">
        <Typography variant="p" fontSize="16px" color="#677389" display="inline-block" textAlign="center">
          {body}
        </Typography>
      </Box>
      {showContactSupport && (
        <Button buttonType="primary" id={INTERCOM_LAUNCHER_ID}>
          <FormattedMessage id="common.contact_support" defaultMessage="Contact support" />
        </Button>
      )}
    </div>
  );
};
export const InformativeDatasourceStatusMessage = React.memo(InformativeDatasourceStatusMessageFC);
